import { render, staticRenderFns } from "./onboardingPackageCard.vue?vue&type=template&id=01fd49b4&"
import script from "./onboardingPackageCard.vue?vue&type=script&lang=js&"
export * from "./onboardingPackageCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports